"use strict";
/**
 * 自定义表格配置，小表格，中表格
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.custom_table = void 0;
var config_1 = require("../../modules/quote/config");
exports.custom_table = {
    Normal1: [
        { title: '序号', value: 'rank' },
        { title: '代码', value: config_1.QuoteItem.代码带链接 },
        { title: '名称', value: config_1.QuoteItem.行情统一链接 },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌额', value: config_1.QuoteItem.涨跌额 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '成交量', value: config_1.QuoteItem.成交量 },
        { title: '成交额', value: config_1.QuoteItem.成交额 },
        { title: '昨收', value: config_1.QuoteItem.昨收价 },
        { title: '今开', value: config_1.QuoteItem.今开价 },
        { title: '最高', value: config_1.QuoteItem.最高价 },
        { title: '最低', value: config_1.QuoteItem.最低价 },
    ],
    ABChangePercent: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '涨跌额', value: config_1.QuoteItem.涨跌额 },
        { title: '加自选', value: 'addzxg' }
    ],
    AB5MinChangePercent: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '五分钟<br />涨跌幅', value: config_1.QuoteItem.涨跌幅_5分钟 },
        { title: '加自选', value: 'addzxg' }
    ],
    ABTurnoverRate: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '换手率', value: config_1.QuoteItem.换手率 },
        { title: '加自选', value: 'addzxg' }
    ],
    ABVolumeRate: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '量比', value: config_1.QuoteItem.量比 },
        { title: '加自选', value: 'addzxg' }
    ],
    ABAmplitude: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '振幅', value: config_1.QuoteItem.振幅 },
        { title: '加自选', value: 'addzxg' }
    ],
    ABAmount: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '成交额', value: config_1.QuoteItem.成交额 },
        { title: '加自选', value: 'addzxg' }
    ],
    ABPE: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '市盈率', value: config_1.QuoteItem.市盈率动态 },
        { title: '加自选', value: 'addzxg' }
    ],
    ABPB: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '市净率', value: config_1.QuoteItem.市净率 },
        { title: '加自选', value: 'addzxg' }
    ],
    ABFlowCapitalValue: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '流通市值', value: config_1.QuoteItem.流通市值 },
        { title: '加自选', value: 'addzxg' }
    ],
    ABMarketValue: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '总市值', value: config_1.QuoteItem.总市值 },
        { title: '加自选', value: 'addzxg' }
    ],
    AB60DayChangePercent: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '60日<br />涨跌幅', value: config_1.QuoteItem.涨跌幅_60日 },
        { title: '加自选', value: 'addzxg' }
    ],
    AB360DayChangePercent: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '年初至今<br />涨跌幅', value: config_1.QuoteItem.年初至今涨跌幅 },
        { title: '加自选', value: 'addzxg' }
    ],
    ABSpeed: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '涨速', value: config_1.QuoteItem.涨速_3分钟 },
        { title: '加自选', value: 'addzxg' }
    ],
    BoardsCPDesc: [
        { title: '名称', value: config_1.QuoteItem.板块链接, tdclass: "td_name" },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '主力<br />净流入', value: config_1.QuoteItem.主力净流入 },
        { title: '领涨股', value: config_1.QuoteItem.板块领涨股 },
        { title: '涨跌幅', value: config_1.QuoteItem.板块领涨股涨跌幅 }
    ],
    BoardsCPDesc2: [
        { title: '板块名称', value: config_1.QuoteItem.板块链接 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '领涨股', value: config_1.QuoteItem.板块领涨股 },
        { title: '涨跌幅', value: config_1.QuoteItem.板块领涨股涨跌幅 }
    ],
    BoardsCPDesc3: [
        { title: '排名', value: 'rank' },
        { title: '板块名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '相关链接', value: 'xglinks' },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '换手率', value: config_1.QuoteItem.换手率 },
        { title: '涨跌家数', value: config_1.QuoteItem.涨跌家数 },
        { title: '领涨股', value: config_1.QuoteItem.板块领涨股 },
        { title: '涨跌幅', value: config_1.QuoteItem.板块领涨股涨跌幅 }
    ],
    BoardsCPDesc4: [
        { title: '排名', value: 'rank' },
        { title: '板块名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '相关链接', value: 'xglinks' },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '换手率', value: config_1.QuoteItem.换手率 },
        { title: '涨跌家数', value: config_1.QuoteItem.涨跌家数 },
        { title: '领跌股', value: config_1.QuoteItem.板块领跌股 },
        { title: '涨跌幅', value: config_1.QuoteItem.板块领跌股涨跌幅 }
    ],
    BoardsCPAsc: [
        { title: '名称', value: config_1.QuoteItem.板块链接, tdclass: "td_name" },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '主力<br />净流入', value: config_1.QuoteItem.主力净流入 },
        { title: '领跌股', value: config_1.QuoteItem.板块领跌股 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 }
    ],
    BoardsPosition: [
        { title: '名称', value: config_1.QuoteItem.板块链接, tdclass: "td_name" },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '增仓占比', value: config_1.QuoteItem.主力净占比 },
        { title: '排名', value: config_1.QuoteItem.主力净占比_排名 },
        { title: '排行变化', value: config_1.QuoteItem.主力净占比_排名变化 }
    ],
    BoardsTurnoverRate: [
        { title: '名称', value: config_1.QuoteItem.板块链接, tdclass: "td_name" },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '换手率', value: config_1.QuoteItem.换手率 },
        { title: '领涨股', value: config_1.QuoteItem.板块领涨股, tdclass: "td_name" },
        { title: '涨跌幅', value: config_1.QuoteItem.板块领涨股涨跌幅 }
    ],
    BoardsSpeed: [
        { title: '名称', value: config_1.QuoteItem.板块链接, tdclass: "td_name" },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '涨速', value: config_1.QuoteItem.涨速_3分钟 },
        { title: '领涨股', value: config_1.QuoteItem.板块领涨股, tdclass: "td_name" },
        { title: '涨跌幅', value: config_1.QuoteItem.板块领涨股涨跌幅 }
    ],
    BoardsAmount: [
        { title: '名称', value: config_1.QuoteItem.板块链接, tdclass: "td_name" },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '成交额', value: config_1.QuoteItem.成交额 },
        { title: '领涨股', value: config_1.QuoteItem.板块领涨股, tdclass: "td_name" },
        { title: '涨跌幅', value: config_1.QuoteItem.板块领涨股涨跌幅 }
    ],
    FFRanking: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '净占比', value: config_1.QuoteItem.主力净占比 },
        { title: '排名', value: config_1.QuoteItem.主力净占比_排名 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 }
    ],
    MainCaptialFlow: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '主力<br />净流入', value: config_1.QuoteItem.主力净流入 },
        { title: '净占比', value: config_1.QuoteItem.主力净占比 }
    ],
    BoardsCaptialFlow: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '主力<br />净流入', value: config_1.QuoteItem.主力净流入 },
        { title: '净占比', value: config_1.QuoteItem.主力净占比 },
        { title: '主力流入<br />最大股', value: config_1.QuoteItem.板块资金流入最大股 }
    ],
    CommonChangePercent: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '涨跌额', value: config_1.QuoteItem.涨跌额 }
    ],
    CommonVolume: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '成交量', value: config_1.QuoteItem.成交量 }
    ],
    CommonAmount: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '成交额', value: config_1.QuoteItem.成交额 }
    ],
    ZXGSTable: [
        { title: '代码', value: config_1.QuoteItem.代码带链接 },
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 }
    ],
    MGSCZFB: [
        { title: '序号', value: 'rank' },
        { title: '代码', value: config_1.QuoteItem.代码带链接 },
        { title: '名称', value: config_1.QuoteItem.行情统一链接, tdclass: "td_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌额', value: config_1.QuoteItem.涨跌额 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '成交量', value: config_1.QuoteItem.成交量 }
    ],
    HSGTTABLE: [
        { title: '序号', value: 'rank' },
        { title: '代码', value: config_1.QuoteItem.代码带链接 },
        { title: '名称', value: config_1.QuoteItem.行情统一链接 },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌额', value: config_1.QuoteItem.涨跌额 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '成交量(手)', value: config_1.QuoteItem.成交量 },
        { title: '加自选', value: 'addzxg' }
    ],
    AHTable: [
        { title: '序号', value: 'rank' },
        { title: '名称', value: config_1.QuoteItem.H股对应的A股行情统一链接 },
        { title: 'H股代码', value: config_1.QuoteItem.代码带链接 },
        { title: '最新价(HKD)', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '港股吧', value: 'gbhklink' },
        { title: 'A股代码', value: config_1.QuoteItem.H股对应的A股代码 },
        { title: '最新价(RMB)', value: config_1.QuoteItem.H股对应的A股最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.H股对应的A股涨跌幅 },
        { title: 'A股吧', value: 'gb_hka_link' },
        { title: '比价（A/H）', value: config_1.QuoteItem.AH股比价 },
        { title: '溢价（A/H）%', value: config_1.QuoteItem.AH股溢价 },
        { title: '加自选', value: 'addzxghk' }
    ],
    AHTable2: [
        { title: '序号', value: 'rank' },
        { title: '名称', value: config_1.QuoteItem.H股对应的A股行情统一链接 },
        { title: 'H股代码', value: config_1.QuoteItem.代码带链接 },
        { title: '最新价(HKD)', value: config_1.QuoteItem.最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '港股吧', value: 'gbhklink' },
        { title: 'A股代码', value: config_1.QuoteItem.H股对应的A股代码 },
        { title: '最新价(RMB)', value: config_1.QuoteItem.H股对应的A股最新价 },
        { title: '涨跌幅', value: config_1.QuoteItem.H股对应的A股涨跌幅 },
        { title: 'A股吧', value: 'gb_hka_link' },
        { title: '比价（A/H）', value: config_1.QuoteItem.AH股比价 },
        { title: '溢价（A/H）%', value: config_1.QuoteItem.AH股溢价 }
    ],
    QQZS: [
        { title: '名称', value: config_1.QuoteItem.带交易状态的名称, tdclass: "qqzs_name" },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌额', value: config_1.QuoteItem.涨跌额 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 }
    ],
    JJSCCOMMON: [
        { title: '序号', value: 'rank' },
        { title: '代码', value: config_1.QuoteItem.代码带链接 },
        { title: '名称', value: config_1.QuoteItem.行情统一链接 },
        { title: '相关链接', value: 'jjetflink' },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌额', value: config_1.QuoteItem.涨跌额 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '成交量', value: config_1.QuoteItem.成交量 },
        { title: '成交额', value: config_1.QuoteItem.成交额 },
        { title: '开盘价', value: config_1.QuoteItem.今开价 },
        { title: '最高价', value: config_1.QuoteItem.最高价 },
        { title: '最低价', value: config_1.QuoteItem.最低价 },
        { title: '昨收', value: config_1.QuoteItem.昨收价 }
    ],
    ZQZS_HOME1: [
        { title: '序号', value: 'rank' },
        { title: '代码', value: config_1.QuoteItem.代码带链接 },
        { title: '名称', value: config_1.QuoteItem.行情统一链接 },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌额', value: config_1.QuoteItem.涨跌额 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '开盘价', value: config_1.QuoteItem.今开价 },
        { title: '最高', value: config_1.QuoteItem.最高价 },
        { title: '最低', value: config_1.QuoteItem.最低价 },
        { title: '昨收', value: config_1.QuoteItem.昨收价 },
        { title: '成交量', value: config_1.QuoteItem.成交量 },
        { title: '成交额', value: config_1.QuoteItem.成交额 },
    ],
    ZQZS_HOME2: [
        { title: '名称', value: config_1.QuoteItem.行情统一链接 },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌额', value: config_1.QuoteItem.涨跌额 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 }
    ],
    WHSC: [
        { title: '代码', value: config_1.QuoteItem.代码带链接 },
        { title: '名称', value: config_1.QuoteItem.行情统一链接 },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌额', value: config_1.QuoteItem.涨跌额 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '开盘', value: config_1.QuoteItem.今开价 },
        { title: '最高', value: config_1.QuoteItem.最高价 },
        { title: '最低', value: config_1.QuoteItem.最低价 },
        { title: '昨收', value: config_1.QuoteItem.昨收价 }
    ],
    ZJLPH: [
        { title: '排名', value: 'rank' },
        { title: '代码', value: config_1.QuoteItem.代码带链接, hide: true },
        { title: '名称', value: config_1.QuoteItem.行情统一链接 },
        { title: '相关链接', value: 'astock_xg_link' },
        { title: '主力净流入', value: config_1.QuoteItem.主力净流入 }
    ],
    HJSC_HOME1: [
        { title: '序号', value: 'rank' },
        { title: '代码', value: config_1.QuoteItem.代码带链接 },
        { title: '品种', value: config_1.QuoteItem.行情统一链接 },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌额', value: config_1.QuoteItem.涨跌额 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '今开', value: config_1.QuoteItem.今开价用昨结计算 },
        { title: '最高', value: config_1.QuoteItem.最高价用昨结计算 },
        { title: '最低', value: config_1.QuoteItem.最低价用昨结计算 },
        { title: '昨结', value: config_1.QuoteItem.昨结 },
        { title: '更新时间', value: config_1.QuoteItem.交易时间 }
    ],
    HJSC_HOME2: [
        { title: '序号', value: 'rank' },
        { title: '代码', value: config_1.QuoteItem.代码带链接 },
        { title: '名称', value: config_1.QuoteItem.行情统一链接 },
        { title: '最新价', value: config_1.QuoteItem.最新价 },
        { title: '涨跌额', value: config_1.QuoteItem.涨跌额 },
        { title: '涨跌幅', value: config_1.QuoteItem.涨跌幅 },
        { title: '今开', value: config_1.QuoteItem.今开价用昨结计算 },
        { title: '最高', value: config_1.QuoteItem.最高价用昨结计算 },
        { title: '最低', value: config_1.QuoteItem.最低价用昨结计算 },
        { title: '昨结', value: config_1.QuoteItem.昨结 },
        { title: '成交量(手)', value: config_1.QuoteItem.成交量 },
        { title: '买量(手)', value: config_1.QuoteItem.买量 },
        { title: '卖量(手)', value: config_1.QuoteItem.卖量 },
        { title: '持仓(手)', value: config_1.QuoteItem.持仓量 },
    ]
};
